import './search-filter-container.css';
import React, { useEffect, useMemo, useRef } from 'react';
import { isNullOrUndefinedOrBlank } from '../../util/isNullOrUndefinedOrBlank';
import { iconClose } from '../../util/icons';

export interface SearchFilterContainerProps {
  children?: React.ReactNode;
  alertSuccess?: string | React.ReactNode;
  alertError?: string | React.ReactNode;
  alignRight?: boolean;
  title?: string | React.ReactNode;
  close(): void;
}

export const SearchFilterContainer: React.FC<SearchFilterContainerProps> = (props: SearchFilterContainerProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const styles = useMemo(() =>
    props.alignRight ? { right: 0 } : {}
    , [props.alignRight]);

  const handleClickOutside = (event: any) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      props.close();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });

  return (
    <div className="search-filter-container-wrapper" style={styles}>
      <div ref={ref => (containerRef.current = ref)} className="search-filter-container">
        {props.title &&
          <div className="search-filter-title">{props.title}</div>
        }
        {!isNullOrUndefinedOrBlank(props.alertSuccess) &&
          <div className="alert alert-success">
            {props.alertSuccess}
          </div>
        }
        {!isNullOrUndefinedOrBlank(props.alertError) &&
          <div className="alert alert-fail">
            {props.alertError}
          </div>
        }
        <div className="search-filter-container-inner">
          {props.children}
        </div>
        <div className="search-filter-container-options">
          <button className="search-filter-container-options-close-button" onClick={props.close}>{iconClose} Done</button>
        </div>
      </div>
    </div>
  );
}
